import CardSystem from '../CardSystem';
import ITask from '../../../Utility/Task/ITask';
import { getCardModifierHandler } from '../../../Prototype/Level/Card/ModifierTypeMap';
import ConnectedModifierHandler from '../Handler/Modifiers/ConnectedModifierHandler';

export default class InitModifiersTask implements ITask<CardSystem> {
    public* execute(system: CardSystem): IterableIterator<number> {
        system.getCardsInPlay().forEach((card) => {
            card.modifiers.forEach((modifier) => {
                const handler = getCardModifierHandler(modifier);

                if (handler instanceof ConnectedModifierHandler) {
                    handler.init({ cardSystem: system });
                }
            });
        });
    }
}
